import Store from 'Services/Store';
import Feature from 'Services/Feature';
import AutomationLayout from 'vcomponents/automation/AutomationLayout.vue';
import AutomationTemplatesSellsy from 'vcomponents/automation/templates/AutomationTemplatesSellsy.vue';
import AutomationListing from 'vcomponents/automation/listing/AutomationListing.vue';
import AutomationBuilder from 'vcomponents/automation/builder/AutomationBuilder.vue';

const checkAccess = (to, from, next) => {
    const isAdmin = Store.get('user').isAdmin;
    if (!Feature.isEnabled('automations') || !isAdmin) {
        return next({ name: 'error.not.found' });
    }
    next();
};

export default [
    {
        path: '/automations',
        name: 'automations',
        component: AutomationLayout,
        beforeEnter: checkAccess,
        children: [
            {
                path: 'templates',
                name: 'automations.templates',
                component: AutomationTemplatesSellsy,
                beforeEnter: checkAccess,
            },
            {
                path: 'listing',
                name: 'automations.listing',
                component: AutomationListing,
                beforeEnter: checkAccess,
            },
        ],
    },
    {
        path: '/automations/builder/:id',
        name: 'automations.flow.builder',
        component: AutomationBuilder,
        beforeEnter: checkAccess,
    },
];
